import React, { PureComponent } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import SimpleItem from '../../components/item/SimpleItem'
import { LoadingFixedHeight }  from '../../components/util/Loading'
import UnableToLoad from '../../components/messages/UnableToLoad'
import { Link } from 'react-router'

export default class SidebarItems extends PureComponent {
  static propTypes = exact({
    dispatch: PropTypes.func.isRequired,
    className: PropTypes.string,
    trackingClass: PropTypes.string,
    title: PropTypes.string.isRequired,
    items: ImmutablePropTypes.orderedSet.isRequired,
    loading: PropTypes.bool.isRequired,
    failedToLoad: PropTypes.bool.isRequired,
    emptyText: PropTypes.string,
    linkTo: PropTypes.string,
    linkToTitle: PropTypes.string,
  })

  render () {
    const {
      dispatch,
      className,
      trackingClass,
      title,
      items,
      loading,
      failedToLoad,
      emptyText,
      linkTo,
      linkToTitle,
    } = this.props

    return (
      <div className={ classnames('sidebox', className ) }>
        <h3 className='sidebox-header'>
          <Link to={ linkTo } title={ linkToTitle }>
            <span>{ title }</span>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200' width='19' height='19' aria-hidden='true' className='widget-box__header__icon'>
              <circle cx='100' cy='100' r='80' fill='none' strokeWidth='14' />
              <line x1='85' y1='70' x2='120' y2='100' strokeWidth='12' />
              <line x1='85' y1='130' x2='120' y2='100' strokeWidth='12' />
            </svg>
          </Link>
        </h3>

        <div className='sidebox-content'>
          <LoadingFixedHeight loading={ loading }>
            { failedToLoad && items.size === 0 &&
              <UnableToLoad errorText='Uutisia ei saatu ladattua.' />
            }

            { emptyText && !failedToLoad && items.size === 0 &&
              <UnableToLoad errorText={ emptyText } />
            }

            { items.map((item, i)=> (
              <SimpleItem
                key={ item.get('id') }
                dispatch={ dispatch }
                item={ item }
                trackingClass={ trackingClass }
                gaItemClickUiElement='Sivupalkin uutisboksi'
              />
            )) }
          </LoadingFixedHeight>
        </div>

      </div>
    )
  }
}
